import { FinishedPlantListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/finished-plant-list.response';
import { PlantLifeState } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/plant-life-state.enum';
import { monthName } from '../../../@commons/@services/front/seed-timing.util';
import { parseLocalDate } from '../../../@commons/utils/local-date.util';

/** Ce qui se lit sous le nom d'une culture finie : une clé de traduction et ses paramètres. */
export interface FinishedReasonText {
  key: string;
  params?: Record<string, string>;
}

/** Les raisons que la liste sait dire ; toute autre se lit « Semble finie ». */
const REASONS: PlantLifeState[] = [
  PlantLifeState.HARVESTED,
  PlantLifeState.CYCLE_DONE,
  PlantLifeState.SEASON_OVER,
  PlantLifeState.TOO_OLD,
  PlantLifeState.FROST_KILLED,
];

/**
 * Pourquoi une culture semble finie, en mots simples (« Récoltée », « Gelée »).
 * Un geste resté sans réponse se dit par la date de la dernière nouvelle :
 * « Pas de nouvelles depuis août », l'année en plus quand ce n'est pas celle
 * d'aujourd'hui. Jamais de reproche : c'est un constat, la personne décide.
 */
export function finishedReasonText(plant: FinishedPlantListResponse, lang: string, today = new Date()): FinishedReasonText {
  if (plant.reason === PlantLifeState.ABANDONED) {
    const lastNews = parseLocalDate(plant.lastNewsDate);
    if (lastNews) {
      const month = monthName(lastNews.getMonth() + 1, lang);
      const since = lastNews.getFullYear() === today.getFullYear() ? month : `${month} ${lastNews.getFullYear()}`;
      return { key: 'home.finished.reason.ABANDONED', params: { since } };
    }
  }
  return { key: REASONS.includes(plant.reason) ? `home.finished.reason.${plant.reason}` : 'home.finished.reason.default' };
}
